import { useIntl } from 'react-intl';
import { Label } from '@rossum/api-client/labels';
import { LabelChip } from '@rossum/components/labels/LabelChip';
import { IconCircleMinus } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';

type LabelsListProps = {
  labels: Label[];
  onLabelDelete: (labelUrl: string) => void;
};

export const LabelsList = ({ labels, onLabelDelete }: LabelsListProps) => {
  const intl = useIntl();

  if (labels.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage({
          id: 'components.sidebarV2.annotationData.labelsList.noLabels',
        })}
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
      {labels.map(label => (
        <LabelChip
          key={label.id}
          name={label.name}
          color={label.color}
          deleteIcon={
            <SvgIcon fontSize="large">
              <IconCircleMinus />
            </SvgIcon>
          }
          onDelete={() => onLabelDelete(label.url)}
        />
      ))}
    </Stack>
  );
};
